module.exports = __webpack_public_path__ + "img/jzy_case_01.508ede3f.jpg";